<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="26" height="28" viewBox="0 0 26 28">
        <path
            d="M13.75 2c-0.969 0-1.75 0.781-1.75 1.75v10.25h-0.5v-8.25c0-0.969-0.781-1.75-1.75-1.75s-1.75 0.781-1.75 1.75v12.25l-2.406-3.203c-0.375-0.5-0.969-0.797-1.594-0.797-1.109 0-2 0.906-2 2 0 0.438 0.141 0.859 0.406 1.203l6 8c0.375 0.5 0.969 0.797 1.594 0.797h10.75c0.719 0 1.344-0.516 1.484-1.219l1.188-6.328c0.047-0.297 0.078-0.609 0.078-0.922v-7.781c0-0.969-0.781-1.75-1.75-1.75s-1.75 0.781-1.75 1.75v4.25h-0.5v-8.25c0-0.969-0.781-1.75-1.75-1.75s-1.75 0.781-1.75 1.75v8.25h-0.5v-10.25c0-0.969-0.781-1.75-1.75-1.75zM13.75 0c1.406 0 2.703 0.797 3.344 2.063 0.219-0.047 0.438-0.063 0.656-0.063 2.063 0 3.75 1.687 3.75 3.75v0.266c2.172-0.125 4 1.547 4 3.734v7.781c0 0.438-0.047 0.875-0.125 1.297l-1.188 6.312c-0.297 1.656-1.75 2.859-3.437 2.859h-10.75c-1.25 0-2.453-0.609-3.203-1.594l-6-8c-0.516-0.688-0.797-1.547-0.797-2.406 0-2.203 1.781-4 4-4 0.656 0 1.453 0.156 2 0.531v-6.781c0-2.063 1.687-3.75 3.75-3.75 0.219 0 0.438 0.016 0.656 0.063 0.641-1.266 1.937-2.063 3.344-2.063z"
        ></path>
    </svg>
</template>

<script>
export default {
    name: "Drag",
};
</script>

<style scoped></style>
